import { useToggle } from "react-use"

import { NonImgAvatar } from "components"
import { Psychologist } from "utils/interfaces"
import { getFaceUrl } from "utils/helpers/psychologistUtil"

interface Props {
    psy: Psychologist
}

export function PsyAvatar({ psy }: Props) {
    const [error, toggleError] = useToggle(false)

    const faceUrl = getFaceUrl(psy.face_url, psy.hash_id)

    return (
        <div key={psy.display_name} className="booking-psy-avatar">
            {error && (
                <NonImgAvatar size="XL" isInverted={true}>
                    {psy.display_name}
                </NonImgAvatar>
            )}
            {!error && (
                <img
                    src={faceUrl}
                    alt={psy.display_name}
                    srcSet={`${faceUrl} 2x`}
                    onError={() => toggleError()}
                />
            )}
        </div>
    )
}
